import { render, staticRenderFns } from "./ZyxxEdit.vue?vue&type=template&id=4fd32685"
import script from "./ZyxxEdit.vue?vue&type=script&lang=js"
export * from "./ZyxxEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports